module.exports = __webpack_public_path__ + "static/media/drag-icon.c716d825.svg";